export default "__VITE_ASSET__1hzi2baU__"